import { React } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './style.css';

const AsyncIndicator = ({ className, message }) => {
    const classes = classNames('async-indicator', className);

    return (
        <div className={classes}>
            <FontAwesomeIcon icon="cog" className="fa-spin" />
            {message && <h5>{message}</h5>}
        </div>
    );
};

export default AsyncIndicator;
